import OrderDTO from "@/dto/order/OrderDTO";
import { ShipValidationResult } from "./type";

export function buildValidationFailedResult(errorMessage?: string): ShipValidationResult {
    return {
        canShip: false,
        canShipOrders: [],
        errorMessage,
    };
}

export function buildValidationSuccessfulResult(orders: OrderDTO[]): ShipValidationResult {
    return {
        canShip: true,
        canShipOrders: orders,
    };
}
